let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aYVrY")).then(() => parcelRequire('5Ijq4'));